import React, {useState} from 'react'
import ReactDOM from 'react-dom'
import { css } from "@emotion/core";
import AllRoutes from './router'
import "react-toggle/style.css"
import {BrowserRouter as Router, useHistory} from 'react-router-dom'
import * as serviceWorker from './serviceWorker'
import { Provider } from 'react-redux'
import ReactPixel from 'react-facebook-pixel';
import store from './redux/store'
import ReactTooltip from 'react-tooltip'
import { HelmetProvider } from 'react-helmet-async'

import './universal.scss'
import './components/universal/notifications/notifications.styling.scss'

const Index = () => {

  const [isLoading, setIsLoading] = useState(true)

  const history = useHistory()

  const advancedMatching = {};
  const options = {
    autoConfig: true,
    debug: false,
  };
  ReactPixel.init('191928612885498', advancedMatching, options);
  ReactPixel.pageView();


  const override = css`
    .tooltip-inner{
      background:none;
      background: transparent !important;
      background-color: white !important;
      font-family: 'Questrial', sans-serif !important;
      opacity: 1;
      border-color: rgb(230, 230, 230) !important;
      border-width: 1px !important;
      border-style: solid !important;
      color: rgb(68, 68, 68) !important;
      box-shadow: 0px 0px 15px rgb(201, 201, 201) !important;
    }
  `;


    return (
      <HelmetProvider>
        <Router history={history}>
          <AllRoutes setIsLoading={setIsLoading} isLoading={isLoading}/>
          <ReactTooltip multiline={true} backgroundColor="black" textColor="#fff" style={override} className="custom-tooltip" arrowColor="black"/>
        </Router>
      </HelmetProvider>
    )
}

ReactDOM.render(
  <Provider store={store}>
    <Index/>
  </Provider>
, document.getElementById('root'));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
